import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Rx';
import { EventManager , JhiLanguageService  } from 'ng-jhipster';

import { Marketplace } from './marketplace.model';
import { MarketplaceService } from './marketplace.service';

@Component({
    selector: 'jhi-marketplace-detail',
    templateUrl: './marketplace-detail.component.html'
})
export class MarketplaceDetailComponent implements OnInit, OnDestroy {

    marketplace: Marketplace;
    private subscription: any;
    private eventSubscriber: Subscription;

    constructor(
        private eventManager: EventManager,
        private jhiLanguageService: JhiLanguageService,
        private marketplaceService: MarketplaceService,
        private route: ActivatedRoute
    ) {
        this.jhiLanguageService.setLocations(['marketplace']);
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe((params) => {
            this.load(params['id']);
        });
        this.registerChangeInMarketplaces();
    }

    load(id) {
        this.marketplaceService.find(id).subscribe((marketplace) => {
            this.marketplace = marketplace;
        });
    }
    previousState() {
        window.history.back();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.eventManager.destroy(this.eventSubscriber);
    }

    registerChangeInMarketplaces() {
        this.eventSubscriber = this.eventManager.subscribe('marketplaceListModification', (response) => this.load(this.marketplace.id));
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketplace/marketplace-detail.component.ts